export function detectListStructureInText(text: string) {
  return text.indexOf("0.") === 0 && text.indexOf("1.") !== -1;
}

export function plainTextToList(text: string) {
  let actual = 0;
  let actualListItem = "";
  const list = [];

  for (let index = 2; index < text.length; index++) {
    if (actual + 1 === parseInt(text[index])) {
      list.push(actualListItem);
      actualListItem = "";
      index = index + 2;
      actual = actual + 1;
    } else {
      actualListItem += text[index];
    }
  }

  return list;
}
